module.exports = __webpack_public_path__ + "img/download_code.95a19cfc.png";